import { useEffect, useState } from 'react';
import LoadingSpinner from '@helpers/LoadingSpinner';
import ConfirmacionConTarjetaClub from '@images/confirmacionConTarjetaClub';
import { EventTrackAndLogData, PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import DetallesVentaBonificada from '../Components/Common/banner/DetallesVentaBonificada';
import ConfirmacionLogin from '../Components/Common/login/src/confirmacion/ConfirmacionLogin';
import useObtenerServiciosNewsletter from '../Hooks/useObtenerServiciosNewsletter';
import useActualizarNewsletter from '../Hooks/useActualizarNewsletter';
import { actualizarProductoPremium } from '../Services/ActualizarProductoPremium';
import useObtenerEventosSuscripciones from '../Services/ObtenerEventosSuscripciones';
import { GuardarEventoProductoPremium } from '../Services/GuardarEventoProductoPremium';
import DataDog from '../Helpers/DataDog';
import UpdateCookies from './../Helpers/UpdateCookies';

const VentaBonificada = ({ state, send }) => {
    const [_, errorObtenerServicios, isLoadingObtenerServicios, obtenerServiciosNewsletter] = useObtenerServiciosNewsletter();
    const [__, errorActualizarServ, isLoadingActualizarServ, actualizarNewsletter] = useActualizarNewsletter();
    const [eventos, errorEventos, isLoadingEventos] = useObtenerEventosSuscripciones(send);
    const [isLoadingVentaBonificada, setIsLoadingVentaBonificada] = useState(false);
    const [newsletterChecked, setNewsletterChecked] = useState(null);
    const planCampania = state.context?.planCampania;

    useEffect(() => {
        PageViewTrackAndLogData('debe_aceptar_terminosycondiciones');
    }, []);

    const getFechaConvertida = (strDate) => {
        const fechaTransf = strDate.split(' ')[0].split('/');
        return new Date(fechaTransf[2], fechaTransf[1] - 1, fechaTransf[0]);
    };

    const dateIsValid = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    const finalizarActivacion = () => {
        UpdateCookies()
            .then(() => {
                if (newsletterChecked) {
                    obtenerServiciosNewsletter()
                        .then(async (respuesta) => {
                            if (respuesta.code === '0') {
                                //se activa newsletter
                                await actualizarNewsletter([30]);
                                EventTrackAndLogData('confirmacion-tyc');
                                // sendEventRUM('Finaliza flujo');
                            }
                        })
                        .catch((error) => {
                            setIsLoadingVentaBonificada(false);
                            EventTrackAndLogData('error-en-acepta-tyc', error);
                        })
                        .finally(() => {
                            send('SUBMIT');
                        });
                } else {
                    send('SUBMIT');
                }
            })
            .catch((error) => {
                setIsLoadingVentaBonificada(false);
                DataDog.trackCustomEventWarning('error-updateCookies-/me-bonificados', error);
                send('ERROR');
            });
    };

    //TODO: config con los estados de tyc
    const handleClickFinalizar = () => {
        if (eventos?.EstadoTyC == 'PendienteActivacion' && eventos?.IsBonificada) {
            setIsLoadingVentaBonificada(true);
            const fechaActivacion = new Date();
            let fechaEventoDate = new Date(eventos?.FechaEvento);
            if (!dateIsValid(fechaEventoDate)) {
                fechaEventoDate = getFechaConvertida(eventos?.FechaEvento);
            }
            actualizarProductoPremium()
                .then((resp) => {
                    //TODO: mover esta logica a un hook
                    if (resp.code == '0000' && resp.response == '0') {
                        //response es 0 cuando se actualizo correctamente el usuarioProdPremium, si vuelve 1 el registro ya existia
                        const eventoGuardar = {
                            SuscripcionId: eventos.SuscripcionId,
                            IsBonificada: eventos.IsBonificada,
                            ProductosPremium: eventos?.ProductosPremium,
                            EstadoId: 3, //3 para activacion
                            EstadoTyC: 'Activa',
                            IdEstadoSuscripcion: eventos.IdEstadoSuscripcion,
                            FechaEvento: fechaEventoDate,
                            EstadoSuscripcion: eventos.EstadoSuscripcion,
                            FechaActivacion: fechaActivacion,
                            //el resto lo saco desde el back
                        };
                        GuardarEventoProductoPremium(eventoGuardar)
                            .then((response) => {
                                if (response.code == '0000') {
                                    finalizarActivacion();
                                } else {
                                    //error al guardar y enviar evento
                                    DataDog.trackCustomEventWarning('errorCode-enviar-evento-alta-bonificado' , { error: response.message, code: response.code });
                                    send('ERROR');
                                }
                            })
                            .catch((error) => {
                                setIsLoadingVentaBonificada(false);
                                send('ERROR');
                            });
                    } else {
                        DataDog.trackCustomEventWarning('errorCode-actualizar-prod-premium-bonificado' , { error: resp.message, code: resp.code });
                        setIsLoadingVentaBonificada(false);
                        send('ERROR');
                    }
                })
                .catch((error) => {
                    setIsLoadingVentaBonificada(false);
                    send('ERROR');
                });
        } else {
            DataDog.trackCustomEventWarning('error-bonificado-estado-incorrecto'); //si el ultimo evento no es pendiente de act, no deberia llegar hasta aca, agrego evento por si acaso
            send('ERROR');
        }
    };

    return (
        <LoadingSpinner isLoading={isLoadingVentaBonificada || isLoadingEventos}>
            <ConfirmacionLogin
                titleText={'¡Bienvenido!'}
                image={<ConfirmacionConTarjetaClub width="201.24" height="160" />}
                firstBtnLabel={'continuar'}
                firstBtnOnClick={handleClickFinalizar}
                showCallbackArticle={false}
            >
                <DetallesVentaBonificada email={state.context?.datosPersonales?.email} setNewsletterChecked={setNewsletterChecked} />
            </ConfirmacionLogin>
        </LoadingSpinner>
    );
};

export default VentaBonificada;
